import { createSlice } from '@reduxjs/toolkit';
import {
  getSuppliersReducers,
  getSupplierReducers,
  updateSupplierReducers,
  getSuppliersListReducers,
  uploadShippingReducers,
  getSupplierShippingPricesReducers,
  upsertSupplierShippingPriceReducers,
  downloadInventoryFileFormatReducers,
  downloadShippingFileFormatReducers,
  getSftpConnectionsReducers,
  createSftpConnectionReducers,
  updateSftpConnectionReducers,
  deleteSftpConnectionReducers,
} from './suppliers.reducers';

const initialState = {
  supplier: null,

  suppliers: [],
  totalSuppliers: 0,
  totalPages: 0,
  currentPage: 1,

  getSuppliersStatus: 'idle',
  getSupplierStatus: 'idle',
  updateSupplierStatus: 'idle',
  uploadShippingStatus: 'idle',
  getShippingPricesStatus: 'idle',
  upsertShippingPriceStatus: 'idle',
  shippingPricesPage: null,
  downloadInventoryFormatStatus: 'idle',
  downloadShippingFormatStatus: 'idle',

  getSuppliersListStatus: 'idle',
  list: [],

  sftpConnections: [],
  getSftpConnectionsStatus: 'idle',
  createSftpConnectionStatus: 'idle',
  updateSftpConnectionStatus: 'idle',
  deleteSftpConnectionStatus: 'idle',

  error: null,
};

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getSuppliersListReducers(builder);
    getSuppliersReducers(builder);
    getSupplierReducers(builder);
    updateSupplierReducers(builder);
    uploadShippingReducers(builder);
    getSupplierShippingPricesReducers(builder);
    upsertSupplierShippingPriceReducers(builder);
    downloadInventoryFileFormatReducers(builder);
    downloadShippingFileFormatReducers(builder);
    getSftpConnectionsReducers(builder);
    createSftpConnectionReducers(builder);
    updateSftpConnectionReducers(builder);
    deleteSftpConnectionReducers(builder);
  },
});

export default suppliersSlice.reducer;
